import { formatTranslation } from '@/common/utils/formatTranslation';
import { SparkSelect } from '../BuyTokensModal.styles';

const BuyTokensCheckoutButton = ({
	canPurchase,
	isPending,
	selectedPrice,
	onClick,
	translations,
}) => {
	const label = isPending
		? translations.processingPayment || 'Processing...'
		: selectedPrice
			? formatTranslation(translations.continueWithPrice, { price: selectedPrice })
			: translations.selectPackageButton;

	return (
		<SparkSelect type="button" disabled={!canPurchase} onClick={onClick}>
			{label}
		</SparkSelect>
	);
};

export default BuyTokensCheckoutButton;
